import React from "react";

export default function ColorFrame28({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path fill="#FFC444" d="M130.094 6.346H144.351V27.731H130.094z"></path>
        <rect
          width="12.475"
          height="26.732"
          x="123.857"
          y="13.475"
          fill="#FFC444"
          rx="6.237"
          transform="rotate(-90 123.857 13.475)"
        ></rect>
        <path
          fill="url(#paint0_linear_2257_162809)"
          d="M26 129C26 67.144 76.144 17 138 17s112 50.144 112 112v43H26v-43z"
        ></path>
        <path
          fill="#ABC4FD"
          d="M0 172.564A3.564 3.564 0 013.564 169h267.872a3.564 3.564 0 013.564 3.564v2.862a7.574 7.574 0 01-7.574 7.574H7.574A7.574 7.574 0 010 175.426v-2.862z"
        ></path>
        <rect
          width="102"
          height="102"
          x="87"
          y="52"
          fill="#fff"
          stroke="#ABC4FD"
          strokeWidth="8"
          rx="9"
        ></rect>
        <path
          fill="#F9D6B2"
          d="M76.844 195.522c-9.703-9.697-7.788-13.354-.83-15.155 12.78-.182 19.584 12.247 32.595 17.289 6.64 2.572 13.168 4.732 16.825 4.894 7.141.316 13.191.553 17.285-.036 4.924-.708 11.081-2.643 10.019-4.732-1.062-2.089-13.801-2.617-17.83-3.675-6.364-1.671-12.003-5.252-11.017-9.683 2.246-10.097 25.4-2.918 33.854-1.927 8.455.991 7.094-.971 19.89-.771 8.025.125 14.367 3.873 19.145 10.25 4.777 6.377 12.13 19.848 26.017 34.093 14.947 15.331 20.082 22.947 20.082 22.947-32.943-11.254-34.925 15.632-42.415 15.3-9.362-.414-1.312-38.798-37.249-29.36-36.42 9.564-39.386.291-59.547-10.446-20.162-10.738-14.967-17.138-26.824-28.988z"
        ></path>
        <path
          fill="#F9D6B2"
          d="M163.3 232.048c-36.454 10.335-39.392.431-59.524-10.985-9.4-5.331-13.274-9.668-15.937-14.063l18.661 7.5c6.633 2.73 16.843 4.838 20.5 5 7.141.316 9.669 1.745 17.287-.091 7.619-1.836 15.713-7.967 33.713-1.909s26 26 26 26c2.233 3.557 5.022 5.883 8.075 7.318 5.562-5.699 14.312-9.981 30.857-3.984 0 0-17.833 10.104-30.857 3.984-5.503 5.639-7.886 12.666-11.61 12.501-9.362-.415-1.195-41.469-37.165-31.271z"
          opacity="0.25"
        ></path>
        <path
          fill="#E5F0FF"
          d="M178.33 237.922l45.89-27.177 11.138 15.593-49.899 24.504-7.129-12.92z"
        ></path>
        <path
          fill="#26264F"
          d="M181.894 249.951l54.8-26.286 19.604 26.286L193.478 270l-11.584-20.049z"
        ></path>
        <circle cx="221.546" cy="221.437" r="2.673" fill="#26264F"></circle>
        <defs>
          <linearGradient
            id="paint0_linear_2257_162809"
            x1="137.754"
            x2="137.542"
            y1="-103.005"
            y2="230.649"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.419" stopColor="#D8E6FD"></stop>
            <stop offset="0.878" stopColor="#BDD0FB"></stop>
          </linearGradient>
        </defs>
        {children}
      </g>
    </svg>
  );
}
